import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-zinc-900" data-id="element-309" data-mp="cng4emis5haj">
      <div className="max-w-6xl mx-auto" data-id="element-310" data-mp="cm52ytct4lml">
        <div className="text-center mb-16" data-id="element-311" data-mp="7p69md0ywipg">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4 text-white" data-id="element-312" data-mp="7nbmcs284ei7">
            The 6-in-1 MMA Coach Ready system
          </h2>
          <p className="text-xl text-zinc-300" data-id="element-313" data-mp="3c4fhar1d524j">
            Six complete coaching volumes. One connected MMA development pathway.
          </p>
          <p className="font-display font-extrabold uppercase tracking-wide text-sm text-amber-400 mt-3" data-id="element-314" data-mp="3pwc7uqndv3yt">
            100% Visual • Ready to open &amp; use
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-315" data-mp="2xd5iuyfkn12p">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-zinc-950 rounded-2xl ${volume.popular ? 'border-2 border-amber-400/80' : 'border border-zinc-800'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-316" data-mp="2sf40kfpyz5sa" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-amber-400 text-zinc-950 font-display font-extrabold text-xs py-1 px-10 rotate-45 shadow" data-id="element-317" data-mp="1vf7kfgsgc9fd">
                  MOST POPULAR
                </div>}

              <div className="mb-5 pr-12" data-id="element-318" data-mp="24hgsm008zqpl">
                <div className="text-amber-400 font-display font-extrabold text-sm uppercase tracking-wider" data-id="element-319" data-mp="24eb70uqtv6ym">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-black uppercase leading-tight mt-1 text-white" data-id="element-320" data-mp="3fu9gv0ttxx0w">
                  {volume.title}
                </h3>
                {volume.eyebrow && <p className="text-red-500 font-display font-extrabold text-sm uppercase tracking-wide mt-2" data-id="element-321" data-mp="1bqogh5g7558p">
                    {volume.eyebrow}
                  </p>}
              </div>

              <p className="text-zinc-200 font-semibold mb-5 border-l-4 border-amber-400 pl-4" data-id="element-322" data-mp="1ktpml652awcd">
                {volume.subtitle}
              </p>

              <div className="space-y-3 mb-5" data-id="element-323" data-mp="t18eedov54q6">
                {volume.intro.map(paragraph => <p key={paragraph} className="text-zinc-400 text-sm leading-relaxed" data-id="element-324" data-mp="16smyknuibbyt">
                    {paragraph}
                  </p>)}
              </div>

              {volume.flow && <div className="mb-6" data-id="element-325" data-mp="ec2e0meah8gp">
                  {volume.flowLabel && <p className="text-sm font-semibold text-zinc-200 mb-2" data-id="element-326" data-mp="9d92v0mh5tjp">{volume.flowLabel}</p>}
                  <FlowSteps steps={volume.flow} align="start" data-id="element-327" data-mp="2l02t6i6f652n" />
                </div>}

              <div className="mb-6 flex-grow" data-id="element-328" data-mp="2prun92osasxj">
                {volume.bulletsLabel && <h4 className="font-sans text-sm font-bold text-zinc-500 uppercase tracking-wider mb-3" data-id="element-329" data-mp="2c06b4zejc4gk">
                    {volume.bulletsLabel}
                  </h4>}
                <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-330" data-mp="34ollv9qmw0m3">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-331" data-mp="38qgp4js4ko2i">
                      <CheckCircle2 size={18} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-332" data-mp="2uqo0cu05shx6" />
                      <span className="text-zinc-300 text-sm" data-id="element-333" data-mp="2zoz9t3mjkqev">{bullet}</span>
                    </li>)}
                </ul>

                {volume.afterFlow && <div className="mt-6" data-id="element-334" data-mp="1oabzum9v6nyf">
                    <FlowSteps steps={volume.afterFlow} align="start" data-id="element-335" data-mp="1obddmyi9loju" />
                    {volume.afterText && <p className="text-zinc-400 text-sm leading-relaxed mt-3" data-id="element-336" data-mp="23ljp3u6k6hg6">{volume.afterText}</p>}
                  </div>}
              </div>

              <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4 mt-auto" data-id="element-337" data-mp="1usgh41eomwsx">
                <span className="text-red-500 font-display font-extrabold uppercase text-sm block mb-1" data-id="element-338" data-mp="1ptn2u6rkn1rp">
                  Result
                </span>
                <p className="text-zinc-200 text-sm" data-id="element-339" data-mp="2mgi959dthem9">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}